import { LearningItem } from '../../models/LearningItem'

export default function learningItemDueDate(learningItem: LearningItem) {
  return learningItem.userLearningAssignments?.reduce(
    (acc, assignment) =>
      assignment.dueDate && assignment.dueDate.valueOf() < (acc?.valueOf() || Number.MAX_SAFE_INTEGER)
        ? assignment.dueDate
        : acc,
    null as Date | null
  )
}
